import { render, staticRenderFns } from "./rootsInSoilLead.vue?vue&type=template&id=3f7b5d48&scoped=true&"
import script from "./rootsInSoilLead.vue?vue&type=script&lang=js&"
export * from "./rootsInSoilLead.vue?vue&type=script&lang=js&"
import style0 from "./rootsInSoilLead.vue?vue&type=style&index=0&id=3f7b5d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b5d48",
  null
  
)

export default component.exports